<template>
  <div>
    <b-form-row class="flex-column">
      <h4>البيانات المالية للمشروع</h4>
      <div class="text-warning mt-1">
        <feather-icon class="mr-25" size="19" icon="AlertTriangleIcon" />
        الميزانية الإجمالية مرصودة بالدولار
      </div>
    </b-form-row>
    <b-form-row>
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12">
        <b-list-group class="rounded border">
          <b-list-group-item class="bg-secondary bg-lighten-3">
            <b-form-row class="text-white">
              <b-col> الميزانية التقديرية الإجمالية</b-col>
              <b-col> الميزانية التقديرية الإجمالية بالليرة السورية</b-col>
              <b-col cols="2"> الميزانية التقديرية الإجمالية للمشروع</b-col>
              <b-col> نسبة النفقات الإدارية </b-col>
              <b-col cols="2">
                القيمة المالية لمساهمة الوكالة الأممية الشريكة
              </b-col>
              <b-col> اسم المصرف </b-col>
              <b-col> محافظة المصرف </b-col>
              <b-col> عنوان المصرف </b-col>
              <b-col> رقم الحساب </b-col>

              <b-col> </b-col>
            </b-form-row>
          </b-list-group-item>
          <template v-if="loadingRecords">
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>جاري التحميل...</strong>
            </div>
          </template>
          <template v-else>
            <template v-if="records.length === 0">
              <span class="text-center my-1" style="opacity: 0.7"
                >لا يوجد سجلات حتى الآن</span
              >
            </template>
            <b-list-group-item
              v-for="(financial, index) in records"
              :key="index"
            >
              <b-form-row class="align-items-center">
                <b-col cols="2">
                  {{
                    new Intl.NumberFormat().format(
                      financial.expected_budget_usd
                    )
                  }}</b-col
                >
                <b-col>
                  {{
                    new Intl.NumberFormat().format(financial.expected_budget_sp)
                  }}
                </b-col>
                <b-col cols="2">
                  {{ financial.administrative_expenses_percentage }}
                </b-col>
                <b-col>
                  {{ new Intl.NumberFormat().format(financial.total_budget) }}
                </b-col>
                <b-col>
                  {{
                    new Intl.NumberFormat().format(
                      financial.un_agent_contribution_value
                    )
                  }}
                </b-col>
                <b-col>
                  {{
                    new Intl.NumberFormat().format(
                      financial.local_ngo_contribution_value
                    )
                  }}
                </b-col>
                <b-col> {{ financial.bank_name }} </b-col>
                <b-col> {{ financial.bank_governorate }} </b-col>
                <b-col> {{ financial.bank_address }} </b-col>
                <b-col> {{ financial.bank_account_id }} </b-col>
                <b-col> {{ financial.account_manager_id }} </b-col>

                <b-col class="justify-content-end d-flex">
                  <b-button
                    @click="
                      $refs.formModal.init(financial);
                      onEditClicked(financial, index);
                    "
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    @click="onDeleteClicked(financial.id)"
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-col>
              </b-form-row>
            </b-list-group-item>
          </template>
        </b-list-group>
        <b-form-row class="px-50 mt-1 d-flex justify-content-end">
          <b-button
            @click="
              $refs.formModal.init({});
              onNewClicked();
            "
            variant="success"
          >
            <feather-icon icon="PlusIcon" />
            <span> إضافة </span>
          </b-button>
        </b-form-row>
      </b-col>
    </b-form-row>
    <form-modal
      title="البيانات المالية للمشروع"
      v-model="modalShown"
      :formSchema="schema"
      static
      :loading="working"
      ref="formModal"
      @confirm="onSaveClickedFinancial"
    >
      <template #bank_account_id="{ form }">
        <form-select
          rules="required"
          label="رقم الحساب"
          v-model="form.bank_account_id"
          id="bank-accounts"
          ep="v2/selects/bank-accounts"
          :reduce="(x) => x.id"
          :getOptionLabel="(x) => x.account_no"
          @option:selected="
            bankId = $event.id;
            $delete(form, 'account_manager_id');
          "
        />
      </template>
      <template #account_manager_id="{ form }">
        <form-select
          rules="required"
          ref="accountManagersSelect"
          label="محرك الحساب"
          v-model="form.account_manager_id"
          id="account-manager"
          :ep.sync="getManagersEp"
          :reduce="(x) => x.id"
          :getOptionLabel="(x) => x.full_name"
        />
      </template>
    </form-modal>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BSpinner,
  BListGroup,
  BListGroupItem,
  BFormRow,
  BCol,
} from "bootstrap-vue";
import FormModal from "@/components/FormModal";
import FormSelect from "@/components/form-select";
import LoaderBtn from "@/components/loader-btn.vue";
import FormCleave from "@/components/FormCleave.vue";
import tableEditMixin from "../mixins/TableEditMixin";

export default {
  mixins: [tableEditMixin],
  components: {
    BButton,
    BFormGroup,
    BSpinner,
    BListGroup,
    BListGroupItem,
    BFormRow,
    BCol,
    LoaderBtn,
    FormModal,
    FormCleave,
    FormSelect,
  },
  data() {
    return {
      bankId: null,
      schema: {
        expected_budget_usd: {
          key: "expected_budget_usd",
          component: "FormCurrency",
          attrs: {
            label: "الميزانية التقديرية الإجمالية",
            raw: false,
            rules: "required",
          },
        },
        expected_budget_sp: {
          key: "expected_budget_sp",
          component: "FormCurrency",
          attrs: {
            label: "الميزانية التقديرية الإجمالية بالليرة السورية",
            raw: false,
            rules: "required",
          },
        },
        administrative_expenses_percentage: {
          key: "administrative_expenses_percentage",
          component: "FormCleave",
          attrs: {
            label: "نسبة النفقات الإدارية",
            raw: false,
            rules: "required",
          },
        },
        total_budget: {
          key: "total_budget",
          component: "FormCurrency",
          attrs: {
            label: "إجمالي الميزانية",
            raw: false,
            rules: "required",
          },
        },
        un_agent_contribution_value: {
          key: "un_agent_contribution_value",
          component: "FormCurrency",
          attrs: {
            label: "القيمة المالية لمساهمة المنظمة الأممية الشريكة",
            raw: false,
            rules: "required",
          },
        },
        local_ngo_contribution_value: {
          key: "local_ngo_contribution_value",
          component: "FormCurrency",
          attrs: {
            label: "القيمة المالية لمساهمة المنظمة الأهلية",
            raw: false,
            rules: "required",
          },
        },

        bank_name: {
          component: "FormInput",
          key: "bank_name",
          attrs: {
            label: "اسم المصرف",
            rules: "required",
          },
        },

        bank_governorate: {
          component: "FormSelect",
          key: "bank_governorate",
          attrs: {
            id: "bank_gov",
            label: "محافظة المصرف ",
            ep: "v2/selects/governorates",
            reduce: (x) => x.name_ar,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        bank_address: {
          component: "FormInput",
          key: "bank_address",
          attrs: {
            label: "عنوان المصرف",
            rules: "required",
          },
        },

        bank_account_id: {
          key: "bank_account_id",
          attrs: {
            id: "bank_account_id",
            label: "رقم الحساب ",
            ep: "v2/selects/bank-accounts",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.account_no,
            rules: "required",
          },
        },
        account_manager_id: {
          key: "account_manager_id",
        },
      },
    };
  },
  methods: {
    async onSaveClickedFinancial(form) {
      if (this.isAdding) {
        await this.addNewRecord({
          endpoint: this.operationsEndpoint,
          form: {
            ...form,
            project_id: this.projectId,
          },
        });
        this.isAdding = false;
      } else {
        await this.updateRecord({
          endpoint: this.operationsEndpoint + "/" + form.id,
          form: {
            ...form,
            project_id: this.projectId,
          },
        });
        this.isEdit = null;
      }
      this.fetchRecords(this.fetchEndpoint);
      this.refreshData();
    },
  },
  watch: {
    bankId(val) {
      this.bankId = val;
      this.$nextTick(() => {
        this.$refs.accountManagersSelect.refreshOptions();
      });
    },
  },
  computed: {
    getManagersEp() {
      return this.bankId ? `v2/selects/account-managers/${this.bankId}` : "v";
    },
    modalShown: {
      set(val) {
        this.isAdding = val;
        this.isEdit = null;
      },
      get() {
        return this.isAdding || this.isEdit !== null;
      },
    },

    fetchEndpoint() {
      return `v2/co-op/project/${this.$route.params.id}/financials`;
    },
    operationsEndpoint() {
      return `v2/co-op/project/financials`;
    },
  },
};
</script>
